<template>
  <div class="oc" :class="{ 'oc-rev': reverse }">
    <figure class="oc-figure reveal" v-reveal>
      <img :src="image" :alt="imageAlt"/>
      <span class="oc-shade"></span>
      <figcaption v-if="caption">{{ caption }}</figcaption>
    </figure>

    <ul class="oc-list">
      <li
        v-for="(o, i) in items"
        :key="o.title"
        class="oc-item reveal"
        v-reveal="{ delay: i * 80 }"
      >
        <span class="oc-check"><IconSvg name="check"/></span>
        <div>
          <h3>{{ o.title }}</h3>
          <p>{{ o.desc }}</p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import IconSvg from './IconSvg'

export default {
  name: 'Outcomes',
  components: { IconSvg },
  props: {
    items: { type: Array, default: () => [] },
    image: { type: String, default: '' },
    imageAlt: { type: String, default: '' },
    caption: { type: String, default: '' },
    reverse: { type: Boolean, default: false }
  }
}
</script>

<style lang="scss" scoped>
.oc {
  display: grid;
  grid-template-columns: 0.95fr 1.05fr;
  gap: 40px;
  align-items: center;
}

.oc-rev {
  grid-template-columns: 1.05fr 0.95fr;

  .oc-figure { order: 2; }
  .oc-list { order: 1; }
}

.oc-figure {
  position: relative;
  margin: 0;
  border-radius: 18px;
  overflow: hidden;
  border: 1px solid var(--line);

  img { width: 100%; aspect-ratio: 16 / 11; object-fit: cover; }

  .oc-shade {
    position: absolute;
    inset: 0;
    background: linear-gradient(180deg, rgba(3, 7, 17, 0.08) 40%, rgba(4, 9, 20, 0.85));
  }

  figcaption {
    position: absolute;
    left: 20px;
    bottom: 16px;
    right: 20px;
    font-size: 13px;
    color: var(--txt-2);
  }
}

.oc-list {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.oc-item {
  display: flex;
  gap: 14px;

  h3 { font-size: 16.5px; color: #fff; }
  p { margin-top: 7px; font-size: 13.8px; line-height: 1.8; color: var(--txt-3); }
}

.oc-check {
  width: 26px;
  height: 26px;
  padding: 5px;
  flex-shrink: 0;
  border-radius: 8px;
  color: var(--accent-txt);
  border: 1px solid color-mix(in srgb, var(--accent) 45%, transparent);
  background: color-mix(in srgb, var(--accent) 10%, transparent);
}

@media (max-width: 1080px) {
  .oc, .oc-rev {
    grid-template-columns: minmax(0, 1fr);
    gap: 26px;

    .oc-figure, .oc-list { order: initial; }
  }
}
</style>
